import { render, staticRenderFns } from "./DictValueForm.vue?vue&type=template&id=4c9236aa"
import script from "./DictValueForm.vue?vue&type=script&lang=js"
export * from "./DictValueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9236aa')) {
      api.createRecord('4c9236aa', component.options)
    } else {
      api.reload('4c9236aa', component.options)
    }
    module.hot.accept("./DictValueForm.vue?vue&type=template&id=4c9236aa", function () {
      api.rerender('4c9236aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dict/DictValueForm.vue"
export default component.exports